import Highcharts from 'highcharts'
import Helper from './Helper';

class DrawHighchart {
  constructor() {
    this.allCharts = document.querySelectorAll('.highchart');
    this.initializedCharts = new Set(); // Keep track of initialized charts

    this.pointWidth = window.innerWidth > 768 ? 40 : 24;

    Highcharts.setOptions({
      lang: {
        decimalPoint: document.documentElement.lang === 'en' ? '.' : ',',
        thousandsSep: document.documentElement.lang === 'en' ? ',' : ' '
      }
    });

    // Intersection Observer setup
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.initializedCharts.has(entry.target)) {
          this.initializeChart(entry.target);
          this.initializedCharts.add(entry.target);
          observer.unobserve(entry.target); // Stop observing after initialization
        }
      });
    }, {
      threshold: 0.5 // Adjust this value based on when you want to initialize (0.5 = 50% of element is visible)
    });

    // Observe each chart
    this.allCharts.forEach(chart => {
      observer.observe(chart);
    });
  }

  initializeChart(chart) {
    if (chart.classList.contains('highchart--column')) {
      this.initColumn(chart);
    } else if (chart.classList.contains('highchart--bar')) {
      this.initBar(chart);
    } else if (chart.classList.contains('highchart--pie')) {
      this.initPie(chart);
    } else {
      //console.log("Unknown Chart type on " + chart.id);
    }
  }

  initBar(chart) {
    const that = this;
    if (!!chart) {
      var chartHeight = '104';
      var chartHeightMobile = '300';

      //daten
      try {
        var json = JSON.parse(chart.innerHTML);

        chart.innerHTML = "red";

        var seriesArr = [];
        seriesArr.push(json.data);

        //console.log([...seriesArr.data].sort((a, b) => a.y < b.y ? 1 : a.y > b.y ? -1 : 0)[0].y);
      } catch (error) {
        //console.log("Invalid JSON on " + chart.id + ": " + error)
      }
      try {
        var chartType = 'bar';
        var chartOptions = {
          title: {
            text: '',
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: false,
          },
          plotOptions: {
            series: {
              pointWidth: this.pointWidth,
              groupPadding: 0,
              pointPadding: 0.0,
              borderWidth: 0,
              borderRadius: 0,

              dataLabels: {
                crop: false,
                overflow: "visible",
                enabled: true,
                inside: false,
                padding: 10,

                formatter: function () {
                  return Highcharts.numberFormat(this.y, that.getDecimalPlaces(this.y));
                }
              },
            },
          },
          xAxis: {
            categories: json.cats,
            title: {
              text: null,
            },
            labels: {
              padding: 0,
              enabled: true,
              shadow: false,
            },
            minPadding: 20,
            maxPadding: 0,
          },
          yAxis: {
            max: [...seriesArr[0].data].sort((a, b) => a.y < b.y ? 1 : a.y > b.y ? -1 : 0)[0].y,
            visible: true,
            title: { text: null },
            labels: {
              shadow: false,
              enabled: false,
            },
            endOnTick: false,
          },
          series: seriesArr,

          chart: {
            styledMode: true,
            height: chartHeight,
            type: chartType,
            spacingRight: 120,
            spacingLeft: 0,
            spacingTop: 0,
            spacingBottom: 0,
            reflow: true,
          },
          tooltip: {
            enabled: false,
          },
          responsive: {
            rules: [{
              condition: {
                maxWidth: 200
              },
              chartOptions: {
                plotOptions: {
                  series: {
                    pointWidth: this.pointWidth
                  },
                  chart: {
                    height: chartHeightMobile
                  }
                }
              }
            }]
          }
        };
        var chart = Highcharts.chart(chart.id, chartOptions);
      } catch (error) {
        //console.log("noChart" + ' ' + error)
      }
    }
  }
  initPie(chart) {
    const that = this;
    try {
      var json = JSON.parse(chart.innerHTML);
      var afterNumString = ' Mio.';
      var seriesArr = [];
      seriesArr.push(json.data);

      //console.log([...seriesArr.data].sort((a, b) => a.y < b.y ? 1 : a.y > b.y ? -1 : 0)[0].y);

    } catch (error) {
      //console.log("Invalid JSON on " + chart.id + ": " + error)
    }

    var chartHeight = '50%';
    var chartType = 'pie';

    const chartDiv = document.querySelector('#' + chart.id);
    //create outside Legend
    const legendDiv = document.createElement('div');
    legendDiv.id = chart.id + '-legend';
    chartDiv.parentNode.appendChild(legendDiv);

    var containerElement = document.querySelector('#' + chart.id);
    var chartOptions = {
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: true,
        float: false,
      },
      events: {
      },
      chart: {
        styledMode: true,
        height: chartHeight,
        type: chartType,
        marginLeft: 20, // Adjust the left margin to make room for labels
        marginRight: 20, // Adjust the right margin to make room for labels
        spacingTop: 20, // Adjust the top spacing to make room for labels
        spacingBottom: 20 // Adjust the bottom spacing to make room for labels
      },
      tooltip: {
        enabled: false,
        shadow: false,
        useHTML: true,
        valueSuffix: afterNumString,
        pointFormat: "<span class='highcharts-color-{point.colorIndex}'>●</span> <b>{point.y:.1f}" + afterNumString + "</b>", // Anzahl Kommastellen nach Punkt for f
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: true,
            connectorShape: 'none',
            connectorWidth: 0, // Set a non-zero width to make the connector line visible
            connectorColor: '#000000', // Change the color as needed
            overflow: "none",
            useHTML: true,
            alignTo: 'plotBox',
            formatter: function () {
                          // Format the number as before
                var formattedNumber = Highcharts.numberFormat(this.y, that.getDecimalPlaces(this.y));


                // Combine the formatted number and the axis title
                return '<div class="bold">'+formattedNumber+': <br /></div>' + this.point.name;

            }
          },
          size: '70%',
          borderRadius: 0,
          padding: 5,
          slicedOffset: 0,
        },
        series: {
          //center: ['25%', '50%'], // This is the key line
          states: {
            hover: {
              halo: null,
            }
          }
        }
      },
      series: seriesArr,
    };
    var chart = Highcharts.chart(chart.id, chartOptions);

    var itemsArray = Array.prototype.slice.call(
      legendDiv.querySelectorAll('.series-outside-legend-item')
    );

    itemsArray.forEach((item, i) => {
      var index = item.getAttribute('data-index');
      var d = chart.series[0].data[index];

      item.addEventListener('click', (e) => {
        var index = item.getAttribute('data-index');
        var d = chart.series[0].data[index];
        let currentItems = Array.prototype.slice.call(document.querySelectorAll(legendSelector + ' .series-outside-legend-item[data-index="' + index + '"]'));
        currentItems.forEach(item => {
          if (item.classList.contains('inactive')) {
            item.classList.remove('inactive');
          } else {
            item.classList.add('inactive');
          }
        })

        if (d.visible) {
          d.setVisible(false);
        } else {
          d.setVisible(true);
        }
      });
    });
  }


  initColumn(chart) {
    const that = this;
    if (!!chart) {
      var chartHeight = '300';
      var chartHeightMobile = '300';

      //daten
      try {
        var json = JSON.parse(chart.innerHTML);

        var seriesArr = [];
        seriesArr.push(json.data);

        //console.log([...seriesArr.data].sort((a, b) => a.y < b.y ? 1 : a.y > b.y ? -1 : 0)[0].y);

      } catch (error) {
        //console.log("Invalid JSON on " + chart.id + ": " + error)
      }
      try {
        var chartType = 'column';
        var chartOptions = {
          title: {
            text: '',
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: false,
          },
          plotOptions: {
            series: {
              pointWidth: this.pointWidth,
              groupPadding: .001, // Adjust this value to reduce the spacing between columns
              pointPadding: .001, // Adjust this value to reduce the spacing between data points within a column
              borderWidth: 0,
              borderRadius: 0,

              dataLabels: {
                crop: false,
                overflow: "visible",
                enabled: true,
                inside: false,
                padding: 10,
                formatter: function() {
                  return Highcharts.numberFormat(this.y, that.getDecimalPlaces(this.y));
                }
              },
            },
          },
          xAxis: {
            categories: json.cats,
            title: {
              text: null,
            },
            labels: {
              padding: 0,
              enabled: true,
              shadow: false,
            },
            minPadding: 20,
            maxPadding: 0,
          },
          yAxis: {
            max: [...seriesArr[0].data].sort((a, b) => a.y < b.y ? 1 : a.y > b.y ? -1 : 0)[0].y,
            visible: true,
            title: { text: null },
            labels: {
              shadow: false,
              enabled: false,
            },
            endOnTick: false,
          },
          series: seriesArr,

          chart: {
            styledMode: true,
            height: chartHeight,
            //width: 201,
            type: chartType,
            spacingRight: 80,
            spacingLeft: 80,
            spacingTop: 50,
            spacingBottom: 0,
            reflow: true,
          },
          tooltip: {
            enabled: false,
          },
          responsive: {
            rules: [{
              condition: {
                maxWidth: 200
              },
              chartOptions: {
                plotOptions: {
                  series: {
                    pointWidth: this.pointWidth
                  },
                  chart: {
                    height: chartHeightMobile
                  }
                }
              }
            }]
          }
        };
        Highcharts.chart(chart.id, chartOptions);
      } catch (error) {
        //console.log("noChart" + ' ' + error)
      }

    }

  }

  getDecimalPlaces(numberStr) {
    const parts = String(numberStr).split('.');
    return parts.length > 1 ? parts[1].length : 0;
  }

}

export default DrawHighchart;
